import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import { CheckboxLabeled } from '@ui/actions'
import { getTensileAnchorsTemplateOptions } from 'src/domain/planTables/constants'
import type { PlanTableTemplateOptions } from 'src/domain/planTables/types'

interface Props {
  templateOptions: PlanTableTemplateOptions | undefined
  onChange: (templateOptions: PlanTableTemplateOptions) => void
}

const TensileAnchorsTemplateOptionsFields = ({
  templateOptions,
  onChange,
}: Props): ReactElement => {
  const { showTotalAnchorCount, showStoreyAnchorCount } =
    getTensileAnchorsTemplateOptions(templateOptions)

  return (
    <Stack spacing={1} data-cy="plan-table-tensile-anchors-options">
      <CheckboxLabeled
        checked={showTotalAnchorCount}
        onChange={event =>
          onChange({ ...templateOptions, showTotalAnchorCount: event.target.checked })
        }
        label="Anzahl gesamt anzeigen"
        data-cy="plan-table-show-total-anchor-count"
      />
      <CheckboxLabeled
        checked={showStoreyAnchorCount}
        onChange={event =>
          onChange({ ...templateOptions, showStoreyAnchorCount: event.target.checked })
        }
        label="Anzahl im Geschoss anzeigen"
        data-cy="plan-table-show-storey-anchor-count"
      />
    </Stack>
  )
}

export default TensileAnchorsTemplateOptionsFields
